import React from "react";
import { useChatContext } from "../chat_context.jsx";

export default function CurrentQuestionMessage() {
  const { currentQuestion } = useChatContext();

  return (
    <div className="d-flex justify-content-end mb-2">
      <div
        className="bg-primary text-white rounded px-3 py-2"
        style={{ maxWidth: "70%" }}
      >
        <div className="text-break">{currentQuestion}</div>
      </div>
    </div>
  );
}

